export const galleryData = [
    // Add your gallery images here. Place them in /public/gallery and set image to "/gallery/<file>.jpg".
    { id: 1, title: 'Gallery Image 1', image: '/gallery/1.jpg', category: 'operations' },
    { id: 2, title: 'Gallery Image 2', image: '/gallery/2.jpg', category: 'equipment' },
    { id: 3, title: 'Gallery Image 3', image: '/gallery/3.jpg', category: 'safety' },
    { id: 4, title: 'Gallery Image 4', image: '/gallery/4.jpg', category: 'operations' },
    { id: 5, title: 'Gallery Image 5', image: '/gallery/5.jpg', category: 'equipment' },
    { id: 6, title: 'Gallery Image 6', image: '/gallery/6.jpg', category: 'operations' },
    { id: 7, title: 'Gallery Image 7', image: '/gallery/7.jpg', category: 'operations' },
    { id: 8, title: 'Gallery Image 8', image: '/gallery/8.jpg', category: 'equipment' },
];
